import { Navigate, Outlet } from 'react-router-dom'
import { useSession } from '../hooks/useSession'
import { useSubscription } from '../hooks/useSubscription'
import PastDueBanner from './PastDueBanner'

/**
 * Wraps all protected app routes.
 * - canceled → hard redirect to /subscription-required
 * - past_due → renders a sticky banner but allows access
 * - role === 'superadmin' → always allowed, whatever the status says
 */
export default function SubscriptionGuard() {
  const { user } = useSession()
  const { status } = useSubscription()

  // Superadmins are never subscription-gated
  if ((user as any)?.role === 'superadmin') {
    return <Outlet />
  }

  if (status === 'canceled') {
    return <Navigate to="/subscription-required" replace />
  }

  return (
    <>
      {status === 'past_due' && <PastDueBanner />}
      <Outlet />
    </>
  )
}
